let state = {};

state.phanHoi = {
    refreshFnCountNew: 0,
};

state.dichVuDiemDen = {
    refreshFnCountNew: 0,
};

state.dichVuLuuTru = {
    refreshFnCountNew: 0,
};

state.dichVuAmThuc = {
    refreshFnCountNew: 0,
};

state.dichVuGiaiTri = {
    refreshFnCountNew: 0,
};

state.dichVuVeDienTu = {
    refreshFnCountNew: 0,
};

state.dichVuVanTaiKhach = {
  refreshFnCountNew: 0,
};

state.diemDen = {
    refreshFnCountNew: 0,
};

state.tourDuLich = {
    refreshFnCountNew: 0,
};

state.luuTru = {
    refreshFnCountNew: 0,
};

state.amThuc = {
    refreshFnCountNew: 0,
};

state.giaiTri = {
    refreshFnCountNew: 0,
};

state.veDienTu = {
    refreshFnCountNew: 0,
};

state.vanTaiKhach = {
  refreshFnCountNew: 0,
};

state.quangCao = {
    refreshFnCountNew: 0,
};

state.menu = {
    refreshFnCount: 0,
};

state.check = {
    checkDVCC: 0,
};
export default state;
